@if (ui.mobileOpen()) {
  <div
    class="as-sidebar-overlay"
    role="button"
    tabindex="0"
    aria-label="Close menu"
    (click)="ui.closeMobile()"
    (keyup.enter)="ui.closeMobile()"
    (keyup.space)="ui.closeMobile()"
  ></div>
}

<nav class="as-sidebar as-sidebar--full-height" [class.is-open]="ui.mobileOpen()" [attr.dir]="dir">
  <button class="as-sidebar__mobile-close" (click)="ui.closeMobile()" aria-label="Close navigation">
    <mat-icon>close</mat-icon>
  </button>

  <div class="as-nav__logo">
    <svg
      class="as-nav__logo-mark"
      viewBox="0 0 121 104"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <polygon
        class="as-nav__logo-mark__primary"
        points="60.6,52.1 31.4,102.7 1.8,102.7 60.6,0.8 75.3,26.4"
      />
      <polygon
        class="as-nav__logo-mark__accent"
        points="119.4,102.7 89.8,102.7 60.6,52.1 75.3,26.4"
      />
    </svg>
    <img class="as-nav__logo-text" src="assets/images/logo_text.svg" alt="Artisan Sonics" />
  </div>

  <ng-content></ng-content>

  <app-docpanel></app-docpanel>
</nav>
